import { jsx as _jsx } from "react/jsx-runtime";

function SvgAccount() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.963 17.703A9 9 0 103 12c0 2.164.764 4.15 2.037 5.703C6.307 15.147 9.331 14 12 14c2.67 0 5.693 1.147 6.963 3.703zm-13.57 3.093a8.21 8.21 0 001.15.815C7.744 22.32 9.544 23 12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12c0 3.596 1.726 6.79 4.394 8.796zM12 21a8.774 8.774 0 004.264-1.124c.483-.268.861-.535 1.122-.738C16.751 17.161 14.522 16 12 16c-2.545 0-4.791 1.183-5.403 3.192l.048.042A8.96 8.96 0 0012 21zm0-14a2 2 0 100 4 2 2 0 000-4zM8 9a4 4 0 118 0 4 4 0 01-8 0z"
    }, void 0)
  }), void 0);
}

export default SvgAccount;